// src/components/ui/Skeleton.js
import React from 'react';

/**
 * Simple skeleton component for loading states
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
const Skeleton = ({ className = '', style = {}, children }) => {
  return (
    <div
      className={`bg-app-gray-300 animate-pulse ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default Skeleton;